// usePlayerConfig.js

import playerTrucLocStore from "../store/playerTrucLoc";

// Custom hook để sử dụng và cập nhật cấu hình player
const usePlayerTrucLoc = (playerId) => {
    const playerTrucLocs = playerTrucLocStore((state) => state.playerTrucLocs);
    const updateSingleTrucLoc = playerTrucLocStore((state) => state.updateSingleTrucLoc);
    const updatePlayerTrucLoc = playerTrucLocStore((state) => state.updatePlayerTrucLoc);
    const updateMultiplePlayersTrucLoc = playerTrucLocStore((state) => state.updateMultiplePlayers);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        trucLoc: playerId == null ? {} : playerTrucLocs[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        playerTrucLocs,
        updateSingleTrucLoc,
        updatePlayerTrucLoc,
        updateMultiplePlayersTrucLoc,
    };
};

export default usePlayerTrucLoc;
